import React, { useContext, memo, Suspense } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { SectionSkeleton } from '../../common/Loaders/Loaders';
import { isB2BUser, isB2Badmin, defineUserType } from '../../../utils/utils';
import { MaxDiscountMessage } from '../../common/MaxDiscountMessage/MaxDiscountMessage';
import {
  UNVERIFIED_DIY,
  UNVERIFIED_ADMIN,
  UNVERIFIED_PURCHASER,
  VERIFIED_USER,
  VERIFIED_ADMIN,
  VERIFIED_PURCHASER
} from '../../../constants/constants';

const UnverifiedDIY = React.lazy(() => import(
  /* webpackChunkName: "UnverifiedDIY" */
  './MilitaryDiscountText/UnverifiedDIY'));

const UnverifiedAdmin = React.lazy(() => import(
  /* webpackChunkName: "UnverifiedAdmin" */
  './MilitaryDiscountText/UnverifiedAdmin'));

const UnverifiedPurchaser = React.lazy(() => import(
  /* webpackChunkName: "UnverifiedPurchaser" */
  './MilitaryDiscountText/UnverifiedPurchaser'));

const VerifiedUser = React.lazy(() => import(
  /* webpackChunkName: "VerifiedUser" */
  './MilitaryDiscountText/VerifiedUser'));

function ProgramSection(props) {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const isTablet = channel === 'tablet';
  const { apiResponse, verifyOnClick } = props;
  const isEnrolled = apiResponse?.enrollmentStatus === 'Y';

  /* These values to be used after SVOC updates for verified Admins and Purchasers */
  // const businessName = enrolledProfile?.companyName;
  // const firstName = enrolledProfile?.firstName;
  // const lastName = enrolledProfile?.lastName;
  const isMilitaryDiscountCapped = apiResponse?.isMilitaryDiscountCapped;
  const isB2B = isB2BUser();
  const isAdmin = isB2Badmin();
  const userType = defineUserType(isB2B, isAdmin, isEnrolled);
  const isUserVerified = userType === VERIFIED_USER || userType === VERIFIED_ADMIN || userType === VERIFIED_PURCHASER;

  return (
    <Grid container xs={12}>
      <Suspense fallback={<SectionSkeleton section="program" />}>
        {userType === UNVERIFIED_DIY && <UnverifiedDIY verifyOnClick={verifyOnClick} />}
        {userType === UNVERIFIED_ADMIN && <UnverifiedAdmin verifyOnClick={verifyOnClick} />}
        {userType === UNVERIFIED_PURCHASER && <UnverifiedPurchaser />}
        {isUserVerified && <VerifiedUser isMilitaryDiscountCapped={isMilitaryDiscountCapped} />}
      </Suspense>
    </Grid>
  );
}

ProgramSection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  apiResponse: PropTypes.objectOf(PropTypes.any),
  verifyOnClick: PropTypes.func,
};
ProgramSection.defaultProps = {
  apiResponse: null,
  verifyOnClick: () => {},
};

export default memo(ProgramSection);
